import { Chip, Tooltip } from '@mui/material';
import { Zap } from 'lucide-react';
import React from 'react';
import type { ApiKey } from '../../types';
import { useTranslation } from 'react-i18next';
import { API_KEY_ACTIONS } from './constants';

export interface CapabilityBadgeProps {
  scope: ApiKey['capabilities'][number];
}

export const CapabilityBadge: React.FC<CapabilityBadgeProps> = ({ scope }) => {
  const { t } = useTranslation();
  const actions = API_KEY_ACTIONS.filter((k) => scope[k])
    .map((k) => t(`apiKeys.actions.${k}`))
    .join(' · ');

  return (
    <Tooltip title={actions || t('apiKeys.actions.none')} arrow placement="top">
      <Chip
        icon={<Zap size={12} />}
        label={scope.capabilityName}
        size="small"
        variant="outlined"
        className="!border-blue-300 !text-xs !text-blue-700 dark:!border-blue-700 dark:!text-blue-300"
      />
    </Tooltip>
  );
};

export interface ApiScopeBadgeProps {
  scope: NonNullable<ApiKey['scopes']>[number];
}

export const ApiScopeBadge: React.FC<ApiScopeBadgeProps> = ({ scope }) => {
  const { t } = useTranslation();
  const restriction = scope.resourceType
    ? `${scope.resourceType}:${scope.resourcePublicId ?? scope.resourceId ?? '*'}`
    : t('apiKeys.modal.allOwnedResources', { defaultValue: 'All owned resources' });

  return (
    <Tooltip title={restriction} arrow placement="top">
      <Chip
        icon={<Zap size={12} />}
        label={scope.scope}
        size="small"
        variant="outlined"
        className="!border-blue-300 !text-xs !text-blue-700 dark:!border-blue-700 dark:!text-blue-300"
      />
    </Tooltip>
  );
};
